import { render, staticRenderFns } from "./studentRegisterTalentUnlock.vue?vue&type=template&id=68637d10&scoped=true"
import script from "./studentRegisterTalentUnlock.vue?vue&type=script&lang=js"
export * from "./studentRegisterTalentUnlock.vue?vue&type=script&lang=js"
import style0 from "./studentRegisterTalentUnlock.vue?vue&type=style&index=0&id=68637d10&prod&scoped=true&lang=css"
import style1 from "./studentRegisterTalentUnlock.vue?vue&type=style&index=1&id=68637d10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68637d10",
  null
  
)

export default component.exports